import { render, staticRenderFns } from "./proBehavior.vue?vue&type=template&id=d31c6d52&scoped=true&"
import script from "./proBehavior.vue?vue&type=script&lang=js&"
export * from "./proBehavior.vue?vue&type=script&lang=js&"
import style0 from "./proBehavior.vue?vue&type=style&index=0&id=d31c6d52&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31c6d52",
  null
  
)

export default component.exports